import styled from "styled-components";
import { FormButton, FormButtonCancel } from "../../../components/Form";
import {
  AuthFormInput,
  AuthFormInputPassword,
  AuthFormInputSpan,
} from "../../auth/styles";

export const Modal = styled.div`
  position: fixed;
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ModalBg = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
`;
export const ModalContent = styled.div`
  position: relative;
  z-index: 10;
  width: 847px;
  background: #ffffff;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  padding: 48px 27px;

  @media screen and (max-width: 1024px) {
    & {
      padding: 24px;
      width: calc(100% - 24px);
      max-height: 100%;
      overflow-y: auto;
      border-radius: 20px;
    }
  }
`;

export const Title = styled.div`
  text-align: center;
  letter-spacing: -0.96px;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  
  margin-bottom: 37px;
  @media screen and (max-width: 1024px) {
    & {
      font-weight: 600;
      line-height: 29px;
      margin-bottom: 23px;
    }
  }
`;

export const BTCValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #F12E11;
  margin-right: 12px;
`;
export const LocalValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #F12E11;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 46px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 59px;
  @media screen and (max-width: 1024px) {
    & {
      display: block;
      border-bottom: none;
      padding-bottom:0;
      margin-bottom: 52px;
    }
  }
`;
export const Row = styled.div`
  &{
    flex:1;

  }
  @media screen and (max-width: 1024px) {
    & {
    }
  }
`;
export const Cell = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 1024px) {
    & {
      display:block;
      height:70px ;
    }
  }
`;
export const CellTitle = styled.div`
  width: 230px;
  font-weight: 400;
  font-size: 16px;
  line-height: 50px;
  color: #818181;
  @media screen and (max-width: 1024px) {
    & {
      font-size: 14px;
      line-height: 25px;
      align-items: center;
    display: flex;
    padding-top:10px;
    }
  }
`;
export const CellValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  border-bottom: 0.5px solid #cccccc;
  font-weight: 600;
  font-size: 16px;
  line-height: 50px;
  color: #000000;

  & a {
    font-weight: 400;
    font-size: 16px;
    color: #548feb !important;
    display: block;
    flex: 1;
  }

  @media screen and (max-width: 1024px) {
    & {
      font-size: 14px;
      height: auto;
      line-height: 25px;
      padding-bottom:10px ;
      max-width: 290px;
      text-overflow: ellipsis;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px;
  margin-top: 50px;
`;
export const FormButtonCancel2 = styled(FormButtonCancel)`
  @media screen and (max-width: 1024px) {
    & {
      width: 100px;
      height: 43px;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      min-width: auto;
    }
  }
`;
export const FormButton2 = styled(FormButton)`
  @media screen and (max-width: 1024px) {
    & {
      width: 280px;
      height: 50px;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      min-width: auto;
      padding:0 ;
    }
  }
`;
export const AuthFormInputPassword2 = styled(AuthFormInputPassword)`
  & {
    box-shadow: none;
    background: #ffffff;
    border-radius: 10px;
    padding-left: 22px;
  }
  &::placeholder {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    /* identical to box height, or 156% */

    color: #818181;
  }
  @media screen and (max-width: 1024px) {
    & {
      height: 52px;
    }
  }
`;
export const AuthFormInput2 = styled(AuthFormInput)`
  & {
    box-shadow: none;
    background: #ffffff;
    border-radius: 10px;
    padding-left: 22px;
  }
  &::placeholder {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    /* identical to box height, or 156% */

    color: #818181;
  }
  @media screen and (max-width: 1024px) {
    & {
      height: 52px;
    }
  }
`;
export const AuthFormInputSpan2 = styled(AuthFormInputSpan)``;
